export default "__VITE_ASSET__5ed9df33__"